// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/OpenSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/OpenSans-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/OpenSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/OpenSans-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
}

.trimble-search {
  margin: 0;
  font-family: "Open Sans", "helvetica neue", helvetica, arial, sans-serif !important;
  font-size: 1rem;
  line-height: 1.625rem;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  --button-hover-bg-color: #e0e1e9;
  --primary-black: #171c1e;
  --primary-black-opacity-60: rgba(23, 28, 30, 0.6);
  --primary-black-opacity-20: rgba(23, 28, 30, 0.2);
}

.trimble-search .sui-layout-body {
  margin-top: 1em;
  margin-bottom: 1em;
  background-color: #ffffff;
  color: var(--primary-black);
}

.trimble-search .sui-layout-body:after {
  content: none !important;
}

.trimble-search .sui-layout-body__inner {
  display: flex;
  flex-direction: row;
  gap: 3rem;
  margin: 0;
  max-width: 100%;
}

.trimble-search .sui-search-error {
  height: 4rem;
  font-family: inherit;
  color: inherit;
}

/* FONTS */

.trimble-search h1 {
  font-family: "Open Sans", sans-serif;
  font-size: 2rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2.5rem;
  letter-spacing: 0.01rem;
  margin: 0;
}

.trimble-search h2 {
  color: var(--primary-black);
  font-family: "Open Sans", sans-serif;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.875rem;
  letter-spacing: 0.00225rem;
  margin-top: 0;
  margin-bottom: 0.5rem !important;
}

.trimble-search h3 {
  font-family: "Open Sans", sans-serif;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.6875rem;
  letter-spacing: 0.00169rem;
  margin: 0;
}

.trimble-search h4 {
  font-family: "Open Sans", "helvetica neue", helvetica, arial, sans-serif !important;
  color: var(--primary-black) !important;
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
  font-weight: bold !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  margin: 0 !important;
}

.trimble-search p,
.trimble-search span,
.trimble-search .rc-pagination-item,
.trimble-search .rc-pagination-item a,
.trimble-search .sui-select *,
.trimble-search .sui-search-box * {
  font-family: "Open Sans", "helvetica neue", helvetica, arial, sans-serif !important;
  font-weight: normal;
  color: var(--primary-black) !important;
}

.trimble-search p.small-text {
  margin: 1em 0 !important;
}

.trimble-search .small-text {
  font-family: "Open Sans", "helvetica neue", helvetica, arial, sans-serif;
  font-size: 0.75rem !important;
  font-weight: 600;
  line-height: 1.25rem !important;
}

.trimble-search a {
  color: var(--primary-black) !important;
  text-decoration: none !important;
}

.trimble-search a:hover {
  color: #54526b !important;
}

.trimble-search .sui-result em {
  color: #363545 !important;
  font-weight: 700 !important;
}

.trimble-search em:after {
  background: none !important;
}

/* PAGE ELEMENTS */

.trimble-search ul {
  list-style: none;
  padding: 0;
  margin-block-start: 0;
  margin-block-end: 0;
}

.trimble-search .centered {
  display: flex;
  margin-top: 2rem;
  justify-content: center;
}

/* spinner */

.trimble-search .searching-spinner {
  margin-top: 3rem;
}

.trimble-search .searching-spinner .modus-spinner {
  transform-origin: center;
  animation: modus-spinner-rotate 2s linear infinite;
}

.modus-spinner circle {
  stroke-linecap: round;
  animation: modus-spinner-dash 2s ease-in-out infinite;
}

@keyframes modus-spinner-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes modus-spinner-dash {
  0% {
    stroke-dasharray: 1 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90 150;
    stroke-dashoffset: -124;
  }
}

/* input, button & line styles */

.trimble-search .button:hover {
  box-shadow: none !important;
  background-color: var(--button-hover-bg-color) !important;
}

.trimble-search button.search-button {
  border: 0 !important;
  background-color: initial;
  cursor: pointer;
}

.trimble-search button.reset-search:focus {
  color: #073a5c;
}

.trimble-search button.reset-search:focus path {
  stroke: #073a5c;
}

.trimble-search button.sui-layout-sidebar-toggle {
  display: none;
}

.trimble-search button.sui-layout-sidebar-toggle svg * {
  stroke: #ffffff;
}

.trimble-search button.sui-layout-sidebar-toggle .filter-count {
  margin-left: 1rem;
  border-radius: 50%;
  height: 1.25rem;
  width: 1.25rem;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 4px 8px #0000001a;
  opacity: 1;
  color: #6a6e79;
  font-size: 0.75rem;
  line-height: 1.25rem;
}

.trimble-search hr {
  border: 0;
  border-bottom: 1px solid #6a6e79 !important;
  margin: 0;
  margin-top: 1rem;
}

/* RESPONSIVENESS */

@media (max-width: 800px) {
  .trimble-search .sui-layout-body {
    display: flex;
    padding: 3rem 1.25rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;
    margin: 0;
  }

  .trimble-search .sui-layout-body__inner {
    flex-direction: column;
    padding: 0;
    margin: 0;
  }

  .trimble-search button.sui-layout-sidebar-toggle {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAiE;AACnE;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAkE;AACpE;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAA8D;AAChE;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAmE;AACrE;;AAEA;EACE,SAAS;EACT,mFAAmF;EACnF,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;EACnC,kCAAkC;;EAElC,gCAAgC;EAChC,wBAAwB;EACxB,iDAAiD;EACjD,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,cAAc;AAChB;;AAEA,UAAU;;AAEV;EACE,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,mFAAmF;EACnF,sCAAsC;EACtC,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;EAC/B,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;;;;;;EAME,mFAAmF;EACnF,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wEAAwE;EACxE,6BAA6B;EAC7B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kBAAkB;;AAElB;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,YAAY;;AAEZ;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;AACF;;AAEA,gCAAgC;;AAEhC;EACE,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,+CAA+C;EAC/C,iCAAiC;EACjC,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,SAAS;EACT,gBAAgB;AAClB;;AAEA,mBAAmB;;AAEnB;EACE;IACE,aAAa;IACb,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(\"./assets/fonts/OpenSans-Regular.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: url(\"./assets/fonts/OpenSans-SemiBold.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(\"./assets/fonts/OpenSans-Bold.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 800;\n  font-display: swap;\n  src: url(\"./assets/fonts/OpenSans-ExtraBold.woff2\") format(\"woff2\");\n}\n\n.trimble-search {\n  margin: 0;\n  font-family: \"Open Sans\", \"helvetica neue\", helvetica, arial, sans-serif !important;\n  font-size: 1rem;\n  line-height: 1.625rem;\n  font-weight: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  --button-hover-bg-color: #e0e1e9;\n  --primary-black: #171c1e;\n  --primary-black-opacity-60: rgba(23, 28, 30, 0.6);\n  --primary-black-opacity-20: rgba(23, 28, 30, 0.2);\n}\n\n.trimble-search .sui-layout-body {\n  margin-top: 1em;\n  margin-bottom: 1em;\n  background-color: #ffffff;\n  color: var(--primary-black);\n}\n\n.trimble-search .sui-layout-body:after {\n  content: none !important;\n}\n\n.trimble-search .sui-layout-body__inner {\n  display: flex;\n  flex-direction: row;\n  gap: 3rem;\n  margin: 0;\n  max-width: 100%;\n}\n\n.trimble-search .sui-search-error {\n  height: 4rem;\n  font-family: inherit;\n  color: inherit;\n}\n\n/* FONTS */\n\n.trimble-search h1 {\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 2rem;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 2.5rem;\n  letter-spacing: 0.01rem;\n  margin: 0;\n}\n\n.trimble-search h2 {\n  color: var(--primary-black);\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 1.5rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.875rem;\n  letter-spacing: 0.00225rem;\n  margin-top: 0;\n  margin-bottom: 0.5rem !important;\n}\n\n.trimble-search h3 {\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 1.25rem;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 1.6875rem;\n  letter-spacing: 0.00169rem;\n  margin: 0;\n}\n\n.trimble-search h4 {\n  font-family: \"Open Sans\", \"helvetica neue\", helvetica, arial, sans-serif !important;\n  color: var(--primary-black) !important;\n  font-size: 1.125rem !important;\n  line-height: 1.75rem !important;\n  font-weight: bold !important;\n  text-transform: none !important;\n  letter-spacing: normal !important;\n  margin: 0 !important;\n}\n\n.trimble-search p,\n.trimble-search span,\n.trimble-search .rc-pagination-item,\n.trimble-search .rc-pagination-item a,\n.trimble-search .sui-select *,\n.trimble-search .sui-search-box * {\n  font-family: \"Open Sans\", \"helvetica neue\", helvetica, arial, sans-serif !important;\n  font-weight: normal;\n  color: var(--primary-black) !important;\n}\n\n.trimble-search p.small-text {\n  margin: 1em 0 !important;\n}\n\n.trimble-search .small-text {\n  font-family: \"Open Sans\", \"helvetica neue\", helvetica, arial, sans-serif;\n  font-size: 0.75rem !important;\n  font-weight: 600;\n  line-height: 1.25rem !important;\n}\n\n.trimble-search a {\n  color: var(--primary-black) !important;\n  text-decoration: none !important;\n}\n\n.trimble-search a:hover {\n  color: #54526b !important;\n}\n\n.trimble-search .sui-result em {\n  color: #363545 !important;\n  font-weight: 700 !important;\n}\n\n.trimble-search em:after {\n  background: none !important;\n}\n\n/* PAGE ELEMENTS */\n\n.trimble-search ul {\n  list-style: none;\n  padding: 0;\n  margin-block-start: 0;\n  margin-block-end: 0;\n}\n\n.trimble-search .centered {\n  display: flex;\n  margin-top: 2rem;\n  justify-content: center;\n}\n\n/* spinner */\n\n.trimble-search .searching-spinner {\n  margin-top: 3rem;\n}\n\n.trimble-search .searching-spinner .modus-spinner {\n  transform-origin: center;\n  animation: modus-spinner-rotate 2s linear infinite;\n}\n\n.modus-spinner circle {\n  stroke-linecap: round;\n  animation: modus-spinner-dash 2s ease-in-out infinite;\n}\n\n@keyframes modus-spinner-rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes modus-spinner-dash {\n  0% {\n    stroke-dasharray: 1 150;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 90 150;\n    stroke-dashoffset: -35;\n  }\n\n  100% {\n    stroke-dasharray: 90 150;\n    stroke-dashoffset: -124;\n  }\n}\n\n/* input, button & line styles */\n\n.trimble-search .button:hover {\n  box-shadow: none !important;\n  background-color: var(--button-hover-bg-color) !important;\n}\n\n.trimble-search button.search-button {\n  border: 0 !important;\n  background-color: initial;\n  cursor: pointer;\n}\n\n.trimble-search button.reset-search:focus {\n  color: #073a5c;\n}\n\n.trimble-search button.reset-search:focus path {\n  stroke: #073a5c;\n}\n\n.trimble-search button.sui-layout-sidebar-toggle {\n  display: none;\n}\n\n.trimble-search button.sui-layout-sidebar-toggle svg * {\n  stroke: #ffffff;\n}\n\n.trimble-search button.sui-layout-sidebar-toggle .filter-count {\n  margin-left: 1rem;\n  border-radius: 50%;\n  height: 1.25rem;\n  width: 1.25rem;\n  background: #ffffff 0% 0% no-repeat padding-box;\n  box-shadow: 0px 4px 8px #0000001a;\n  opacity: 1;\n  color: #6a6e79;\n  font-size: 0.75rem;\n  line-height: 1.25rem;\n}\n\n.trimble-search hr {\n  border: 0;\n  border-bottom: 1px solid #6a6e79 !important;\n  margin: 0;\n  margin-top: 1rem;\n}\n\n/* RESPONSIVENESS */\n\n@media (max-width: 800px) {\n  .trimble-search .sui-layout-body {\n    display: flex;\n    padding: 3rem 1.25rem;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1.5rem;\n    margin: 0;\n  }\n\n  .trimble-search .sui-layout-body__inner {\n    flex-direction: column;\n    padding: 0;\n    margin: 0;\n  }\n\n  .trimble-search button.sui-layout-sidebar-toggle {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
